import { ReportDetails } from 'app/modules/Reports/ReportDetails';
import { ReportDetail } from 'app/modules/Reports/ReportDetails/ReportDetail';
import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { TaxReturnTabsRoutes } from './TarReturnTabs';

export const ReportsRouting = () => {
  return (
    <Routes>
      <Route
        path="taxreturn"
        element={
          <RouteAuth access={[Role.PaymentsAdmin, Role.DetailsReports, Role.TaxreturnReports]}>
            <TaxReturnTabsRoutes />
          </RouteAuth>
        }
      />

      <Route
        path="details"
        element={
          <RouteAuth access={[Role.DetailsReports]}>
            <ReportDetails />
          </RouteAuth>
        }
      />
      <Route
        path="details/:id"
        element={
          <RouteAuth access={[Role.DetailsReports]}>
            <ReportDetail />
          </RouteAuth>
        }
      />
    </Routes>
  );
};
